import {
  TextInput,
  SelectInput,
  required,
  AutocompleteInput,
  useRecordContext
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { ACTION_SOURCE_CHOICES, PLATFORM_TYPE_CHOICES, PLATFORM_TYPES } from '../../../../../config/constants/apiConstants';
import { countries } from '../../../../../config/constants/countries';
import { JsonBooleanInput } from '../../../../helperComponents/JsonBooleanInput';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const MainTab = ({ isEdit }) => {
  const platformType = useWatch({ name: 'platform_type' });
  const isMeta = platformType !== PLATFORM_TYPES.GOOGLE;

  return (
    <>
      <SelectInput
        source="platform_type"
        label="Platform"
        choices={PLATFORM_TYPE_CHOICES}
        className="custom-input-width"
        validate={required()}
      />
      {isEdit && <TextInput source="id" label="ID" disabled={true} />}
      {isMeta && (
        <TextInput
          source="domain_path"
          label="Domain Path"
          className="custom-input-width"
          validate={required()}
        />
      )}
      {isMeta && (
        <>
          <TextInput
            source="fb_pixel_id"
            label="Facebook pixel ID"
            className="custom-input-width"
            validate={required()}
          />
          <TextInput
            source="fb_api_key"
            label="Facebook API key"
            fullWidth
            multiline
            validate={required()}
          />
          <TextInput
            source="event_source_url"
            label="Event source URL"
            className="custom-input-width"
            validate={required()}
          />
          <SelectInput
            source="action_source"
            label="Action Source"
            choices={ACTION_SOURCE_CHOICES}
            className="custom-input-width"
            validate={required()}
          />
        </>
      )}
      {!isMeta && (
        <>
          <Box border={1} borderColor="#d32f2f" p={2} sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle1" gutterBottom>
              Please share the Google Spreadsheet with <strong>google-conversions-api@igneous-future-492621-s8.iam.gserviceaccount.com</strong> in order to connect it to the Conversions API Settings
            </Typography>
          </Box>
          <TextInput
            source="google_sheet_url"
            label="Google Sheet URL"
            fullWidth
            validate={required()}
          />
          <TextInput
            source="google_sheet_name"
            label="Google Sheet Name"
            className="custom-input-width"
            defaultValue="Conversions"
          />
        </>
      )}
      {isMeta && (
        <AutocompleteInput
          source="country"
          label="Country"
          choices={countries}
          className="custom-input-width"
          optionText="name"
          optionValue="id"
          helperText="Will apply to Tune data and TrackCB data if missing."
        />
      )}
    </>
  );
};
